import { render, staticRenderFns } from "./Server_Component.vue?vue&type=template&id=681d078a&scoped=true&"
import script from "./Server_Component.vue?vue&type=script&lang=js&"
export * from "./Server_Component.vue?vue&type=script&lang=js&"
import style0 from "./Server_Component.vue?vue&type=style&index=0&id=681d078a&prod&lang=scss&"
import style1 from "./Server_Component.vue?vue&type=style&index=1&id=681d078a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d078a",
  null
  
)

export default component.exports